<template>
  <span>
    <div class="page-level-functions">
      <router-link to="/">
        <action-button
          variant="outline-success float-right ml-3"
          text="Regresar"
          i="fas fa-arrow-circle-left"/>
      </router-link>
    </div>
    <hr class="page-level-functions-separator" />
    <div class="sub-content-wrapper">
      <search-criteria-entry @searchClicked="onClickSearchHandler">
        <div class="col-md-6 col-sm-12">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text input-icon">
                <em class="fas fa-lg fa-search" />
              </span>
            </div>
            <input
              ref="filterInput"
              type="text"
              class="form-control filter-input"
              :placeholder="search.inputText.placeholder"
              :maxlength="search.inputText.maxlength"
              v-model="search.inputText.model"/>
          </div>
        </div>
        <div class="col-md-3 col-sm-12 mt-2 mt-md-0 mt-sm-2">
          <custom-drop-down
            fieldkey="id"
            fieldname="name"
            @input="onChangedApplicationsHandler"
            :placeholder="search.ddlApplications.placeholder"
            :options="search.ddlApplications.options"
            v-model="search.ddlApplications.model"/>
        </div>
        <div class="col-md-3 col-sm-12 mt-2 mt-md-0 mt-sm-2">
          <custom-drop-down
            fieldkey="id"
            fieldname="name"
            :disabled="search.ddlModules.disabled"
            :placeholder="search.ddlModules.placeholder"
            :options="search.ddlModules.options"
            v-model="search.ddlModules.model"/>
        </div>
      </search-criteria-entry>
      <div class="row mt-3">
        <custom-title-divider title="Información de las Navegaciones"></custom-title-divider>
      </div>
      <div class="mx-n3">
        <result-not-found v-if="result.model.length === 0" />
        <div v-for="(row, index) in result.model" :key="`row-app-${index}`">
          <callout class="my-3" :has-toggle="false">
            <div class="row my-0">
              <div class="col-md-10">
                <div class="row mt-2">
                  <div class="col-md-1 d-flex align-items-center mr-n4">
                    <em class="fas fa-2x fa-globe align-middle row-icon" />
                  </div>
                  <div class="col-md-2">
                    <div class="color-secondary-6 font-16">Aplicación</div>
                    <div class="color-black font-16 font-weight-normal">{{ row.application.name }}</div>
                  </div>
                  <div class="col-md-2">
                    <div class="color-secondary-6 font-16">Módulo</div>
                    <div class="color-black font-16 font-weight-normal">{{ row.module.name }}</div>
                  </div>
                  <div class="col-md-1">
                    <div class="color-secondary-6 font-16">Orden</div>
                    <div class="color-black font-16 font-weight-normal">{{ row.order }}</div>
                  </div>
                  <div class="col-md-2">
                    <div class="color-secondary-6 font-16">Nombre</div>
                    <div class="color-black font-16 font-weight-normal">{{ row.name }}</div>
                  </div>
                  <div class="col">
                    <div class="color-secondary-6 font-16">Descripción</div>
                    <div class="color-black font-16 font-weight-normal">{{ row.description }}</div>
                  </div>
                </div>
              </div>
              <div class="col-md-2 d-flex justify-content-end align-items-center pr-5">
                <router-link :to="'/interfaces/' + row.id ">
                  <action-button
                    variant="outline-success enter-button mr-2"
                    text="Entrar"
                    i="fas fa-sign-in-alt"
                    min-width="100px"/>
                </router-link>
              </div>
            </div>
          </callout>
        </div>
        <pagination
          v-if="showPagination"
          :show-text="true"
          @pagination-go-page="onClickPaginationHandler"
          :data="result.pagination"
        />
      </div>
    </div>
  </span>
</template>

<script>
import InterfacesServices from '@/modules/interfaces/api'
import SearchCriteriaEntry from '@/components/common/SearchCriteriaEntry'
import CustomTitleDivider from '@/components/common/CustomTitleDivider'
import Pagination from 'Pagination'
import ActionButton from 'ActionButton'
import Callout from 'custom-callout'
import ResultNotFound from 'custom-result-not-found'
import CustomDropDown from 'custom-drop-down'
import storeMixin from '@/mixins/storeGenerator';

const initialSearchState = () => ({
  inputText: {
    placeholder: 'Escriba Nombre o Descripción',
    maxlength: 100,
    model: null,
  },
  ddlApplications: {
    placeholder: 'Seleccione Aplicación',
    options: [],
    model: null,
  },
  ddlModules: {
    placeholder: 'Seleccione Módulo',
    disabled: true,
    options: [],
    model: null,
  },
});

const initialResultState = () => ({
  data: [],
  pagination: {
    totalItemCount: 0,
    count: 15,
    pageCount: 0,
    currentPage: 1,
  },
});

export default {
  name: 'InterfacesSearch',
  components: {
    SearchCriteriaEntry,
    CustomTitleDivider,
    ActionButton,
    Callout,
    ResultNotFound,
    Pagination,
    CustomDropDown
  },
  mixins: [storeMixin],
  data() {
    return {
      search: initialSearchState(),
      result: initialResultState(),
    }
  },
  computed: {
    showPagination() {
      return this.result.model.length > 0 && this.result.pagination.totalItemCount > this.result.pagination.count;
    },
  },
  beforeRouteEnter(_, from, next) {
    next((vm) => {
      if (from.name == 'home') {
        vm.shouldRecovery = false;
        vm.search = initialSearchState();
        vm.result = initialResultState();
      } else vm.recoveryData();

      vm.getResult(vm.result.pagination.currentPage);
    });
  },
  async created() {
    await this.getApps();
  },
  destroyed() {
    this.persistData();
  },
  methods: {
    async getApps() {
      const { data } = await InterfacesServices.getApplications();
      this.search.ddlApplications.options = [...data];
    },
    async onChangedApplicationsHandler(app) {
      this.search.ddlModules.model = null;

      if (!app) {
        this.search.ddlModules.disabled = true;
        return;
      }

      this.search.ddlModules.disabled = false;

      await InterfacesServices.getModules(app.id)
        .then(res => {
          const items = res.data;
          this.search.ddlModules.options = items;

          if (items.length == 1) {
            this.search.ddlModules.model = items[0];
          }
        });
    },
    onClickSearchHandler() {
      this.getResult();
    },
    onClickPaginationHandler(page) {
      this.getResult(page);
    },
    async getResult(pageNumber = 1) {
      const filters = {
        filterText: this.search.inputText.model ?? null,
        applicationId: this.search.ddlApplications.model?.id ?? null,
        moduleId: this.search.ddlModules.model?.id ?? null,
        pageNumber,
        pageSize: this.result.pagination.count,
      };

      await InterfacesServices.getByFilters(filters).then(res => {
        this.result = {
          ...this.result,
          model: res.data.data,
          pagination: {
            ...this.result.pagination,
            currentPage: pageNumber,
            totalItemCount: res.data.totalItemCount,
            pageCount: res.data.pageCount
          }
        }
      });
    },
  },
}
</script>

<style scoped>
.enter-button {
  float: right;
}
.row-icon {
  color: #ff7058;
}
</style>
